import queryKeys from '@/constants/queryKeys';
import appRoutes from '@/constants/routes/app';
import { postProvider } from '@/services/api/requests/providers';
import { TProvider } from '@/types/Provider.types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import useToast from '../useToast';
import { TCustomAxiosError } from '@/services/api';

const useCreateProvider = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const toast = useToast();

  const { isPending, isSuccess, mutate } = useMutation({
    mutationFn: async ({ form, photo }: { form: TProvider; photo: File | null }) => {
      const response = await postProvider({ form, photo });
      return response;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [queryKeys.providers.all] });
      toast({ status: 'success', title: 'Success', description: 'Provider successfully created.' });
      navigate({ to: appRoutes.providers });
    },
    onError: (error: TCustomAxiosError) => {
      toast({ status: 'error', title: 'Creating provider error', description: error.errors?.[0]?.message });
    },
  });

  return { isPending, isSuccess, mutate };
};

export default useCreateProvider;
